import { ApplicationRef, ComponentRef, EnvironmentInjector, Injectable, createComponent, inject } from '@angular/core';
import { GuiFacade } from '@app/store/gui';
import { tap } from 'rxjs/operators';

import { SpinnerComponent } from '../spinner.component';

const FADE_DURATION_MS = 200;

@Injectable({
    providedIn: 'root',
})
export class GuiSpinnerService {
    private guiFacade = inject(GuiFacade);
    private applicationRef = inject(ApplicationRef);
    private environmentInjector = inject(EnvironmentInjector);

    private componentRef?: ComponentRef<SpinnerComponent>;

    init(): void {
        this.guiFacade.isLoading$.pipe(tap((value) => (value ? this.show() : this.hide()))).subscribe();
    }

    show(): void {
        if (this.componentRef) {
            return;
        }

        this.componentRef = createComponent(SpinnerComponent, { environmentInjector: this.environmentInjector });
        this.applicationRef.attachView(this.componentRef.hostView);

        const host = <HTMLElement>this.componentRef.location.nativeElement;
        document.body.appendChild(host);
        host.animate([{ opacity: 0 }, { opacity: 1 }], { duration: FADE_DURATION_MS, easing: 'ease-out' });
    }

    hide(): void {
        if (!this.componentRef) {
            return;
        }

        const ref = this.componentRef;
        this.componentRef = undefined;

        const host = <HTMLElement>ref.location.nativeElement;
        const animation = host.animate([{ opacity: 1 }, { opacity: 0 }], { duration: FADE_DURATION_MS, easing: 'ease-in' });
        animation.finished.finally(() => ref.destroy());
    }
}
